"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.schedule.date': '发布日期',
    'socialMediaPlan.schedule.time': '时间',
    'socialMediaPlan.schedule.summary': '摘要',
    'socialMediaPlan.schedule.draftTitle': '草稿',
    'socialMediaPlan.schedule.draftDesc': '保存为草稿',
    'socialMediaPlan.schedule.reviewTitle': '审核',
    'socialMediaPlan.schedule.reviewDesc': '请求审核',
    'socialMediaPlan.schedule.scheduledTitle': '已计划',
    'socialMediaPlan.schedule.scheduledDesc': '稍后发布',
    'socialMediaPlan.schedule.publishedTitle': '已发布',
    'socialMediaPlan.schedule.publishedDesc': '立即发布',
};
